"use client"

import { useTransition } from "react"
import { useParams, useRouter } from "next/navigation"
import { activateVehicleAndShop } from "@lib/data/fitment"

type ShopVehicleButtonProps = {
  vehicle: {
    base_vehicle_id: number
    year: number
    make: string
    model: string
  }
  className?: string
  children: React.ReactNode
}

// "Shop with your vehicle set" from a vehicle-specific page: the page
// already knows the vehicle, so set it as the active garage vehicle and land
// on the results page pre-filtered — never bounce through an empty selector.
export default function ShopVehicleButton({
  vehicle,
  className,
  children,
}: ShopVehicleButtonProps) {
  const countryCode = (useParams().countryCode as string) ?? "us"
  const router = useRouter()
  const [pending, startTransition] = useTransition()

  return (
    <button
      type="button"
      className={className}
      disabled={pending}
      data-testid="shop-vehicle-button"
      onClick={() =>
        startTransition(async () => {
          await activateVehicleAndShop(vehicle)
          router.push(`/${countryCode}/vehicle`)
        })
      }
    >
      {pending ? "Setting your vehicle..." : children}
    </button>
  )
}
